// API/IndexAPI.js
import apiService from '../../Utils/APIService';

class IndexAPI {
    // Handle Login flow
    async handleLogin(mobileNumber, brand = 'qikerp') {
        if (!mobileNumber || mobileNumber.length !== 10) {
            throw new Error('Please enter a valid 10-digit mobile number');
        }

        try {
            // Send OTP
            const otpResponse = await apiService.sendOTP(mobileNumber);

            if (otpResponse?.d?.error === false) {
                // Parse response data to check C and L values
                if (otpResponse?.d?.data) {
                    try {
                        const responseData = JSON.parse(otpResponse.d.data);
                        const tableData = responseData?.Table?.[0];

                        const C = tableData?.C || 0;
                        const L = tableData?.L || 0;
                        const leadOTP = tableData?.LeadOTP || '';

                        // If C=1, redirect to biziverse
                        if (C === 1) {
                            return {
                                success: true,
                                redirectUrl: `https://biziverse.com/?i=${mobileNumber}`,
                            };
                        }

                        // If L=1 (Lead), redirect to Guide with leadOTP
                        if (L === 1) {
                            return {
                                success: true,
                                redirectUrl: `/QikERP/Guide?i=${mobileNumber}&o=${leadOTP}&z=main&m=qik`,
                            };
                        }

                        // If neither C nor L (new user), redirect to Join01
                        return {
                            success: true,
                            redirectUrl: `https://biziverse.com/Join01.html?i=${mobileNumber}&x=Desktop_QikERP`,
                        };

                    } catch (parseErr) {
                        console.error('Error parsing response data:', parseErr);
                    }
                }

                // Fallback: redirect to signup if data parsing fails
                return {
                    success: true,
                    redirectUrl: `https://biziverse.com/Join01.html?i=${mobileNumber}&x=Desktop_QikERP`,
                };

            } else {
                throw new Error(otpResponse?.d?.message || 'Failed to send OTP');
            }
        } catch (err) {
            console.error('Login error:', err);
            throw err;
        }
    }
}

const indexAPI = new IndexAPI();
export default indexAPI;